import PasswordFind from '../../../components/Auth/PasswordFind';
import './FindAuthForm.css';
import './find.css';

const FindPage = () => {
    return (
        <div className="findPage">
            <PasswordFind />
        </div>
    );
};

export default FindPage;
